module.exports = __webpack_public_path__ + "static/media/community-like-post.c22197e1.svg";